export const QualityControlIcon = () => {
  return (
    <svg
    width="25"
    height="25"
    viewBox="12 12 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_16773_42061"
        maskUnits="userSpaceOnUse"
        x="12"
        y="12"
        width="24"
        height="24"
          {...{ "mask-type": "luminance" }}
      >
        <path
          d="M35.25 35.25V12.75H12.75V35.25H35.25Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_16773_42061)">
        <path
          d="M24.0001 29.8389C20.7806 29.8389 18.1614 27.2196 18.1614 24.0001C18.1614 20.7807 20.7806 18.1614 24.0001 18.1614C27.2196 18.1614 29.8388 20.7807 29.8388 24.0001C29.8388 27.2196 27.2196 29.8389 24.0001 29.8389Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M21.6909 23.9732L23.2646 25.5469L26.358 22.4535"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M35.2968 25.4127V22.5874L33.0199 21.926C32.7858 20.9074 32.3826 19.9528 31.8424 19.0925L32.987 17.0109L30.9891 15.013L28.9075 16.1576C28.0473 15.6174 27.0926 15.2142 26.074 14.9801L25.4126 12.7032H22.5873L21.9259 14.9801C20.9073 15.2142 19.9526 15.6174 19.0924 16.1576L17.0108 15.013L15.013 17.0109L16.1575 19.0925C15.6173 19.9528 15.2142 20.9074 14.9801 21.926L12.7031 22.5874V25.4127L14.9801 26.0741C15.2142 27.0926 15.6173 28.0473 16.1575 28.9076L15.013 30.9892L17.0108 32.987L19.0924 31.8424C19.9526 32.3827 20.9073 32.7858 21.9259 33.0199L22.5873 35.2969H25.4126L26.074 33.0199C27.0926 32.7858 28.0473 32.3827 28.9075 31.8424L30.9891 32.987L32.987 30.9892L31.8424 28.9076C32.3826 28.0473 32.7858 27.0926 33.0199 26.0741L35.2968 25.4127Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};
